export default __webpack_public_path__ + "static/media/angry-at-ping.f1d340ab.gif";